import { bronze, gold, platinum, silver } from "components/Subscription/constant";
import { DeviceType, PlanType } from './SubCard';
import { isTenantLookupDomain } from "services/api/tenantResolver";


export const sorter = (x: { orderId: number }, y: { orderId: number }) => {
  if (x.orderId > y.orderId) {
    return 1;
  }
  if (x.orderId < y.orderId) {
    return -1;
  }
  return 0;
};


export function combineBaseWithIOS(arr:any) {
  const baseItems = arr.filter((item: { platform: string; }) => item.platform === 'ANDROID');
  const iosItems = arr.filter((item: { platform: string; }) => item.platform === 'IOS');

  return baseItems.map((baseItem: any) => {
    const matchingIOS = iosItems.find((iosItem:any) => iosItem.durationType === baseItem.durationType&&iosItem.name === baseItem.name);
    if (matchingIOS) {
      return {
        ...baseItem,
        iosexternalPlanId: matchingIOS.externalPlanId,
        iosPlanId: matchingIOS.id,
        iosCurrency: matchingIOS.currency,
        iosPricingValue: matchingIOS.pricingValue,
      };
    } else {
      return baseItem;
    }
  });
}
function mergeData(combinedData: any,device:DeviceType) {
  const mergedData: any = {};

  combinedData.forEach((item: any,) => {
    let otherInfo = {};
    switch (item.name) {
      case "GOLD":
        otherInfo = gold;
        break;
      case "PLATINUM":
        otherInfo = platinum;
        break;
      case "SILVER":
        otherInfo = silver;
        break;
      default:
        otherInfo = bronze;
    }
    if (!mergedData[item.name]) {
      mergedData[item.name] = {
        ...otherInfo,
        id: item.id,
        isFree: item.type === "FREE",
        price: {
          currency: device==="ios"?   item.iosCurrency : item.currency,
          duration: {},
        },
      };
    }
    mergedData[item.name].price.duration[item.durationType] = {
      cost: item.pricingValue,
      id: item.id,
      save: item.discountValue ? item.discountValue : "more",
      ios: item.iosPricingValue || "",
      iosPlanId: item.iosPlanId,
      iosExternalPlanId: item.iosexternalPlanId,
    };
  });

  const mergedArray = Object.keys(mergedData).map((plan) => {
    const access = mergedData[plan].access;
    const header = mergedData[plan].header;
    const price = mergedData[plan].price;
    const id = mergedData[plan].id;
    const orderId = mergedData[plan].orderId;
    const iosPlanId = mergedData[plan].iosPlanId;
    const isFree = mergedData[plan].isFree;
    return {
      id,
      iosPlanId,
      access,
      header,
      price,
      orderId,
      isFree,
    };
  });

  return mergedArray.sort(sorter);
}

function withStaticFreeBronze(plans: PlanType[]): PlanType[] {
  if (!isTenantLookupDomain()) {
    return plans;
  }

  const hasBronze = plans.some((plan) => plan.header.name === "Bronze");
  if (hasBronze) {
    return plans;
  }

  return [{ ...bronze, isFree: true }, ...plans].sort(sorter);
}

export function processSubscriptionData(data: any,device:DeviceType) {
  const combinedData = combineBaseWithIOS(data.data);
  const processedData = mergeData(combinedData,device);
  return withStaticFreeBronze(processedData);
}
